export default {
  props: {
    onListingPage: true,
    hasTour: true,
    realtors: [
      {
        displayEmail: 'sseller@example.com',
        displayPhone: '555-456-5555',
        displayPhotoUrl: 'https://online.sibcycline.com/photos/size/agents/6760/528.jpg',
        displayPrimary: 'Sally Seller',
        displaySecondary: 'Executive Sales Vice President',
        displayWebsiteUrl: 'https://sseller.example.com/',
        designations: 'ABR, CMS, SFR, SRS'
      },
      {
        displayEmail: 'mlister@example.com',
        displayPhone: '555-123-5555',
        displayPhotoUrl: 'https://online.sibcycline.com/photos/size/agents/6737/528.jpg',
        displayPrimary: 'Mark Lister',
        displaySecondary: 'REALTOR®',
        displayWebsiteUrl: 'https://mlister.example.com/',
        designations: 'CRS®, GRI'
      }
    ]
  }
};
